import { render, staticRenderFns } from "./UsersGroupDisplayView.vue?vue&type=template&id=00fcea3c&"
import script from "./UsersGroupDisplayView.vue?vue&type=script&lang=js&"
export * from "./UsersGroupDisplayView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports